import React from 'react'
import LeftCard from './LeftCard'
import RightCard from './RightCard'


export default function Project() {
    let projects = [
        {
            name: 'Chess King',
            description: 'A real-time two-person chess game where users send challenges to other users online. Rating is given to a user based on the win count using Elo\'s rating system. User\'s play history can be found on a dashboard beautifully designed.',
            tags: ['React.js', 'Node.js', 'Sockets.io'],
            image: `chess.png`,
            links: [{name:`cat.png`, link: "https://github.com/Jintumoni/chess-king-frontend"}, {name :`webLink.png`, link: "https://letsplaychessking.netlify.app/"}]
        },
        {
            name: 'Path Finder',
            description: 'A  visualization tool to find the path between two points making its way through any obstacles present in its path. Users can create custom obstacles or choose from a varied range of maze-generating algorithms to apply a range of path-finding algorithms on them.',
            tags: ['React.js', 'Node.js'],
            image: `pathviz.png`,
            links: [{name:`cat.png`, link: "https://github.com/Jintumoni/Path-Finding-Visualizer"}, {name :`webLink.png`, link: "https://pathsviz.netlify.app/"}]
        },
        {
            name: 'CP Parser',
            description: 'A problem parser that takes the input and expected output from an online judge. It sets up a local environment to test the output of your code against the expected output and gives feedback whether it passed the samples or not.',
            tags: ['Node.js'],
            image: `cptool.png`,
            links: [{name:`cat.png`, link: "https://github.com/Jintumoni/Parsing-Tool"}]
        }
    ]
    
    return (
        <div id="projects" className="relative pb-40 pt-10">
            <div className="bg-black-700  w-11/12 max-w-5xl m-auto z-10">
                <h1 className="text-4xl text-center lg:text-5xl text-green-300 font-mono lg:text-left font-black 
                ">Hall Of Projects</h1>
                <div className="mt-20">
                {
                    projects.map((project, index) => {
                        if(index&1){
                            return (<RightCard name={project.name} description={project.description} tags={project.tags} image={project.image} links={project.links}/>)
                        }
                        else{
                            return (<LeftCard name={project.name} description={project.description} tags={project.tags} image={project.image} links={project.links}/>)
                        }
                    })
                }
                </div>
            </div>
        </div>
    )
}
